<template>
	<div class="role">
		<el-button @click="addAdminPerson" class="add qjc-fts-16">添加管理人員</el-button>
		<el-table :data="list" style="width: 100%">
			<template slot="empty">
				<div class="empty-wrap">
					<el-image class="empty-img" :src="require('@/assets/images/empty-history.png')"></el-image>
					<div class="empty-text">暫無數據</div>
				</div>
			</template>
			<el-table-column label="編號" prop="id" min-width="60"></el-table-column>
			<el-table-column label="賬號" prop="username" min-width="140">

			</el-table-column>
			<el-table-column label="姓名" prop="realname">
				<template slot-scope="scope">
					<div class="">{{scope.row.realname ? scope.row.realname : '--'}}</div>
				</template>
			</el-table-column>
			<el-table-column label="手機號" prop="mobile" min-width="120">
				<template slot-scope="scope">
					<div class="">{{scope.row.mobile ? scope.row.mobile : '--'}}</div>
				</template>
			</el-table-column>
			<el-table-column label="角色" prop="role_name" min-width="120">
				<template slot-scope="scope">
					<div class="">{{scope.row.role_name }}</div>
				</template>
			</el-table-column>
			<el-table-column label="企業" prop="company_name" min-width="180">
				<template slot-scope="scope">
					<div class="">{{scope.row.company_id != 0 ? scope.row.company_name : '企業賬號'}}</div>
				</template>
			</el-table-column>

			<el-table-column label="是否啓用" prop="status">
				<template slot-scope="scope">
					<span class="order_status_80" v-if="scope.row.status == 10 ">啓用</span>
					
					<span class="pay_status_1" v-else>停用</span>
				</template>
			</el-table-column>

			<el-table-column label="操作日期" prop="updated_at" min-width="180">
				<template slot-scope="scope">
					<div class="">{{scope.row.updated_at ? scope.row.updated_at : '--'}}</div>
				</template>
			</el-table-column>
			<el-table-column label="操作" prop="action" min-width="180">
				<template slot-scope="scope">
					
						<i v-if="scope.row.id != '1'" @click="editAdminPerson(scope.row)" class="el-icon-edit"></i>
				</template>
			</el-table-column>



		</el-table>


		<!-- 分頁 -->
		<el-pagination @current-change="pageChange" :current-page.sync="pager.page" hide-on-single-page prev-text="上一頁"
			next-text="下一頁" :page-size="pager.pagesize" layout="total, prev, pager, next,jumper" :total="pager.count">
		</el-pagination>


		<el-dialog :title="dialogTitle" :visible.sync="isHandlePerson" width="50%" :close-on-click-modal="false">
			<el-form :model="dialogForm" :rules="dialogFormRules" ref="dialogForm">
				<el-form-item label="賬號名稱" prop="username" min-width="120" required>
					<el-input v-model.trim="dialogForm.username" placeholder="請輸入" :maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="賬號密碼" prop="password" min-width="120" :required="!isEdit">
					<el-input type="password" show-password v-model.trim="dialogForm.password"
						:placeholder="isEdit ? '無需修改則不必輸入' : '請輸入'" :maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="角色" prop="role_id" min-width="120" required >
					<el-select v-model="dialogForm.role_id" placeholder="請選擇" @change="changeRoleId">
						<el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="企业" prop="company_id" min-width="120" required v-if="dialogForm.role_id != 1">
					<el-select v-model="dialogForm.company_id" placeholder="請選擇">
						<el-option v-for="item in deptList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				<el-form-item label="人員姓名" prop="realname" min-width="120">
					<el-input v-model.trim="dialogForm.realname" placeholder="請輸入" :maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="手機號" prop="mobile" min-width="120">
					<el-input v-model.trim="dialogForm.mobile" placeholder="請輸入" :maxlength="20"></el-input>
				</el-form-item>
				<el-form-item label="是否啓用" prop="status" min-width="120" required>
					<el-switch active-value="10" inactive-value="0" v-model="dialogForm.status" active-color="#13ce66"
						inactive-color="#ff4949">
					</el-switch>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button class="cancel-btn" @click="cancelDialogForm">取消</el-button>
				<el-button class="submit-btn" @click="submitDialogForm">提交</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getAdminList,
		adminCompany,
		adminRole
	} from '@/js/axios.js';
	import {
		dateStrChangeTimeTamp,
		isPhone
	} from '@/utils';
	import {
		Base64
	} from 'js-base64'

	export default {
		name: 'adminList',
		data() {
			const validateMobile = (rule, value, callback) => {
				if (value && !isPhone(value)) {
					callback(new Error('請輸入正確格式的手機號碼'));
				} else {
					callback();
				}
			};
			return {
				submiting: false, // 正在請求
				list: [], //列表
				usedList: [],
				id: '',
				pager: {
					count: 0, // 總條數
					page: 1, // 當前頁
					pagecount: 0, // 總頁數
					pagesize: 10 // 每頁條數
				},
				isAlert: false,
				oper: '',
				oper2: '',
				disc: '',
				downAct: 'coupon',
				isAlert2: false,
				remarkId: '',
				newRemark: '',
				isUsedShow: false,
				typeOptions: [{
					value: '1',
					label: '男',
				}, {
					value: '2',
					label: '女',
				}],
				packageOptions: [],
				dialogTitle: "新增",
				isHandlePerson: false,
				dialogForm: {
					role_id:""
				},
				dialogFormRules: {
					username: [{
						required: true,
						message: "請輸入賬號名稱",
						trigger: 'blur'
					}],
					password: [{
						required: true,
						message: "請輸入賬號密碼",
						trigger: 'blur'
					}],
					company_id: [{
						required: true,
						message: "請選擇企业",
						trigger: 'change'
					}],
					role_id: [{
						required: true,
						message: "請選擇角色",
						trigger: 'change'
					}],
					status: [{
						required: true,
						message: "請選擇用户狀態",
						trigger: 'change'
					}],
					mobile: [{
						validator: validateMobile,
						trigger: 'blur',
						message: "請輸入正確格式的手機號碼"
					}]

				},
				deptList: [],
				adminId: "",
				isEdit: false,
				passwordRule: [{
					required: true,
					message: "請輸入賬號密碼",
					trigger: 'blur'
				}],
				roles:[]


			};
		},

		mounted() {
			this.getList();
			this.getAdminRole()
			this.getDeptList();
		},
		components: {},
		watch: {

		},
		methods: {
			getAdminRole(){
					const data = {
						act:'role'
					}
					adminRole(data).then(res => {
						if (res.code == 200) {
							const result = JSON.parse(Base64.decode(res.data))
							this.roles = result
						} else{
							this.roles = []
						}
						
					})
			},
			handlePackage(e) {

			},
			handleStatus(val) {

			},
			// 獲取列表
			getList() {
				getAdminList({
					page: this.pager.page, // 當前頁
					pagesize: this.pager.pagesize, // 每頁條
				}).then(res => {
					if (res.code == 200) {
						let list = JSON.parse(Base64.decode(res.data));
						this.list = list.data;
						this.pager = list.pager;
						this.pager.count = Number(list.pager.count)


					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				});
			},
			getDeptList() {
				adminCompany({
					act: 'list'
				}).then((res) => {
					if (res.code == 200) {
						let result = JSON.parse(Base64.decode(res.data))
						this.deptList = result
					} else {
					}
				})
			},
			resetDialogForm() {
				this.dialogForm = {
					username: "",
					password: "",
					mobile: "",
					realname: "",
					status: '10',
					company_id: "",
					role_id:""
				}
				this.dialogTitle = ""
				this.adminId = ""
				
				
			},

			pageChange(page) {
				this.pager.page = page;
				this.getList();
			},
			addAdminPerson() {
				this.dialogTitle = "新增管理人員"
				this.isHandlePerson = true
				this.isEdit = false
				const rules = JSON.parse(JSON.stringify(this.dialogFormRules))
				rules.password = this.passwordRule
				this.dialogFormRules = rules
				this.resetDialogForm()
				this.$nextTick(() => {
					this.$refs.dialogForm.resetFields()
				})
				
			},
			editAdminPerson({
				id
			}) {
				this.resetDialogForm()
				this.adminId = id
				this.dialogTitle = "修改管理人員"
				getAdminList({
					act: "detail",
					id
				}).then((res) => {
					if (res.code == 200) {
						const detail = JSON.parse(Base64.decode(res.data))
						this.dialogForm = detail
						if (this.dialogForm.company_id === '0') {
							this.dialogForm.company_id = ""
						} 
						this.isEdit = true
						const rules = JSON.parse(JSON.stringify(this.dialogFormRules))
						rules.password = []
						this.dialogFormRules = rules
						this.isHandlePerson = true
					} else {
						this.$myAlert({
							type: 'fail',
							title: res.msg
						});
					}
				})
			},
			delAdminPerson() {

			},
			cancelDialogForm() {
				this.isHandlePerson = false
				this.resetDialogForm()
			},
			submitDialogForm() {
				this.$refs.dialogForm.validate(isSuc => {
					if (isSuc) {
						const data = JSON.parse(JSON.stringify(this.dialogForm))
						if (this.adminId) {
							data.id = this.adminId
							data.act = 'update'
						} else {
							data.act = 'add'
						}
						getAdminList(data).then(res => {
							if (res.code == 200) {
								this.isHandlePerson = false
								this.resetDialogForm()
								this.getList()
							} else {
								this.$myAlert({
									type: 'fail',
									title: res.msg
								});
							}
						})

					}
				})
			},
			changeRoleId(val){
				if(val == 1){
					this.dialogForm.company_id = ""
				}
			}
		}
	};
</script>

<style scoped>
	.el-dialog .el-form .el-form-item>>>.code_cell .el-input__inner {
		padding-right: 80px !important;
	}

	.el-dialog .el-form .el-form-item>>>.el-date-editor.el-input,
	.el-dialog .el-form .el-form-item>>>.el-date-editor.el-input__inner {
		width: 100%;
	}

	.el-dialog .el-form .el-form-item>>>.el-select {
		width: 100%;
	}

	.el-dialog .el-form>>>.el-form-item {
		margin-bottom: 8px;
	}

	.el-dialog .el-form>>>.el-form-item__label {
		width: 16%;
		padding-right: 24px;
		margin-left: 4%;
		text-align: right;
	}

	.el-dialog .el-form>>>.el-form-item__content {
		float: left;
		width: 60%;
		margin-right: 0;
	}

	.right-wrap>>>.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #6681FA;
	}

	.right-wrap>>>.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #6681FA;
		border-color: #6681FA;
	}

	.right-wrap>>>.el-switch__core:after {
		background-color: #828DBC;
	}

	.right-wrap>>>.el-switch.is-checked .el-switch__core::after {
		background-color: #6681FA;
	}

	.right-wrap>>>.el-input-number__increase {
		display: none;
	}

	.right-wrap>>>.el-input-number__decrease {
		display: none;
	}

	.right-wrap .input-number>>>.el-input__inner {
		height: 30px;
		border: none;
		border-bottom: 1px solid #CED4F0;
		border-radius: 0;
		padding: 0;
		margin-left: 10px;
	}

	.used_dialog>>>.el-dialog__body {
		padding: 0 20px 30px;
	}

	::v-deep input::-webkit-outer-spin-button,
	::v-deep input::-webkit-inner-spin-button {
		-webkit-appearance: none !important;
	}

	::v-deep input[type='number'] {
		line-height: 1;
		-moz-appearance: textfield !important;
	}

	.role>>>.el-button:active {
		color: #fff !important;
		border: none;
		background-color: #6883FB !important;
	}

	.role>>>.el-button--default:focus {
		color: #fff !important;
		border: none;
		background-color: #6883FB !important;
	}

	.role>>>thead th {
		background: #FAFBFC;
		color: #40444D;
		font-size: 14px;
		font-weight: 500;
	}
</style>
<style lang="scss" scoped>
	.role {
		width: 100%;
		height: 100%;
		padding: 20px;
		background-color: #fff;
		padding-top: 4px;
		overflow: auto;

		.left-menus {
			min-width: 170px;
			width: 170px;
			padding: 30px 24px;
			border-right: 1px solid #E5E8F5;
			background-color: #ffffff;

			.add-action {
				display: flex;
				align-items: center;
				cursor: pointer;

				.add-action-img {
					display: flex;
					align-items: center;
					align-items: center;
					width: 24px;
					height: 24px;
					background-color: #6883FB;
					border-radius: 50%;

					&::after {
						content: "+";
						width: 100%;
						font-size: 20px;
						color: #fff;
						text-align: center;
						margin-bottom: 4px;
					}
				}

				.add-action-text {
					font-size: 14px;
					color: #6883FB;
					margin-left: 8px;
				}
			}

			.left-list {
				padding-top: 20px;
			}

			.left-enp-item {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #525866;
				line-height: 20px;
				cursor: pointer;
			}

			.left-enp-item-active {
				padding: 12px 0;
				font-size: 15px;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 500;
				color: #6883FB;
				line-height: 20px;
			}
		}

		.right-wrap {
			flex: 1;
			padding: 36px 24px;
			overflow: auto;

			.right-temp {
				margin-bottom: 32px;

				.temp-title {
					display: flex;
					align-items: center;
					justify-content: space-between;
					font-size: 18px;
					font-family: PingFangSC-Regular, PingFang SC;
					font-weight: 400;
					color: #293033;
					line-height: 24px;
					padding-bottom: 10px;
					border-bottom: 1px solid #E5E8F5;
				}

				.temp-info {
					margin-top: 12px;
				}
			}

			.submit-btn {
				width: 94px;
				height: 34px;
				font-size: 15px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #FFFFFF;
				line-height: 34px;
				background-color: #6883FB;
				border-radius: 17px;
				border: none;
				margin-top: 10px;
			}

			.info-cell {
				margin-bottom: 20px;
			}

			.input-number {
				width: 50px;
			}

			.custom-info {
				position: relative;
				width: 670px;
				padding: 24px;
				border: 1px solid #CED4F0;
				border-radius: 4px;
				margin-top: 10px;

				&::before {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -16px;
					left: 41px;
					padding: 0;
					border-top: 8px solid transparent;
					border-left: 8px solid transparent;
					border-right: 8px solid transparent;
					border-bottom: 8px solid #fff;
					display: block;
					content: '';
					z-index: 12;
				}

				&::after {
					box-sizing: content-box;
					position: absolute;
					width: 0;
					height: 0;
					top: -18px;
					left: 40px;
					padding: 0;
					border-top: 9px solid transparent;
					border-left: 9px solid transparent;
					border-right: 9px solid transparent;
					border-bottom: 9px solid #CED4F0;
					display: block;
					content: '';
					z-index: 10;
				}
			}

			.custom-group {
				display: flex;
				flex-direction: row;
				flex-wrap: wrap;

				.custom-item {
					display: flex;
					align-items: center;
					justify-content: space-between;
					width: 30%;
					margin-right: 20px;
				}
			}
		}

		.add {
			padding: 8px 12px;
			margin-top: 8px;
			color: #fff;
			border: none;
		}

		.el-table {
			margin-top: 16px;

			i[class^=el-icon] {
				margin-right: 16px;
				cursor: pointer;
			}
		}

		.el-pagination {
			text-align: center;
			margin-top: 32px;
		}

		.el-dialog {

			.dialog-title {
				font-size: 18px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #293033;
				text-align: center;
			}

			.all-power {
				-webkit-appearance: none;
				background-color: #FFF;
				background-image: none;
				border-radius: 4px;
				border: 1px solid #DCDFE6;
				box-sizing: border-box;
				color: #606266;
				display: inline-block;
				font-size: inherit;
				height: 40px;
				line-height: 40px;
				outline: 0;
				padding: 0 15px;
				transition: border-color .2s cubic-bezier(.645, .045, .355, 1);
				width: 100%;
			}

			.dialog-footer {
				display: flex;
				align-items: center;
				justify-content: center;

				.cancel-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #6883FB;
					border: 1px solid #6883FB;
					border-radius: 17px;
					background-color: #fff;
				}

				.submit-btn {
					width: 94px;
					height: 34px;
					font-size: 14px;
					font-family: PingFangSC-Medium, PingFang SC;
					font-weight: 500;
					color: #fff;
					border: none;
					border-radius: 17px;
					background-color: #6883FB;
					margin-left: 16px;
				}

				.el-button {
					padding: 9px 15px;
				}
			}
		}
	}

	.quota_cell {
		position: relative;
		display: flex;
		align-items: center;

		.unit {
			position: absolute;
			right: 10px;
			top: 0px;
		}
	}

	.times_cell {
		display: flex;
		align-items: center;

		.noTimes {
			height: 40px;
			padding: 0 12px;
			margin-left: 10px;
			border: 1px solid #DCDFE6;
			border-radius: 4px;
		}

		.active {
			border: 1px solid #6681FA;
		}
	}

	.empty-wrap {
		padding: 100px 0;
	}

	.empty-img {
		width: 338px;
		height: 218px;
	}

	.code_cell {
		position: relative;
		display: flex;
		align-items: center;

		input {
			padding-right: 80px;
		}

		.code_btn {
			position: absolute;
			top: 0;
			right: 20px;
			font-size: 14px;
			font-family: PingFang SC-Light, PingFang SC;
			font-weight: 300;
			color: #6883FB;
			cursor: pointer;
			z-index: 99;
		}
	}



	.user_btn {
		color: #6681FA;
		cursor: pointer;
	}

	.el-pagination {
		text-align: center;
		margin-top: 32px;
	}

	.tips_p {
		font-size: 14px;
		padding: 0 78px;
		margin-bottom: 10px;
		text-align: left;

	}

	.btn-danger {
		color: red;
	}
	
	.action-btn{
		color: #6883FB;
		cursor: pointer;
	}
</style>